import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { SearchService } from '@boma/supplier-portal/shared/services';

@Component({
  selector: 'boma-department-selector',
  templateUrl: './boma-department-selector.component.html',
  styleUrls: ['./boma-department-selector.component.scss'],
})
export class BomaDepartmentSelectorComponent implements OnInit {
  @Input() department: { id: string; name: string };
  @Input() disabled = false;
  @Output() updateData = new EventEmitter();

  departments$: Subscription;
  selectedDepartment: any;
  departmentSearchResults: any = [];

  constructor(private searchService: SearchService) {}

  ngOnInit(): void {
    this.departments$ = this.searchService
      .getDepartments('')
      .subscribe((result) => {
        this.departmentSearchResults = result;
        this.selectedDepartment = this.department ? this.department : null;
      });
  }

  handleDepartmentChange(ev) {
    this.selectedDepartment = ev.value;
    this.updateData.emit(ev.value);
  }
}
